import React from 'react';
import { 
  BrowserRouter as Router, 
  Switch,
  Route,
  Link
} from "react-router-dom";
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Header from './Componants/Header';
import Footer from './Componants/Footer';
import Home from './Views/Home';
import Budget from './Views/Budget';


ReactDOM.render(
  <React.StrictMode>
    

    <Router>
    <Header />
    
      
      <div className="Pad">
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/about">
            <Budget />
          </Route>
        </Switch>
      </div>

      <Footer />
    </Router>

    
  </React.StrictMode>,
  document.getElementById('root')
);

